<template>
  <footer class="container-fluid">
    <div class="row">
  		<div class="col-md-12 small">
  			<span class='float-right'>Dojo v{{version}}</span>
  			<aside>&copy; 2016-2020 — Curators of the University of Missouri. All rights reserved. <a href="http://missouri.edu/dmca/">DMCA</a> and <a href="http://missouri.edu/copyright/">other copyright information</a>. An <a href="http://missouri.edu/eeo-aa/">equal opportunity/access/affirmative action/pro-disabled and veteran employer</a>.</aside>
  		</div>
    </div>
    <!-- <img src="img/hek-badge-black@2x.png" width="160px" alt="Hekademeia Research Solutions"> -->
  </footer>
</template>

<script>
export default {
  data(){
    return {
      version: VERSION
    }
  }
}
</script>
